import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from '@/context/AuthContext'

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext)
  // Throwing beats returning a null-shaped default: a component rendered outside
  if (!value) throw new Error('useAuth must be used inside <AuthProvider>')
  return value
}
